export default __webpack_public_path__ + "static/media/ESPN.904867aa.svg";